import React from "react";
import { Icon } from "antd";

export const NotesComponent = props => {
  return (
    <section className={"annotation-widget note-access-" + props.access}>
      <div className="annotation-widget-header">
        <div className="annotation-widget-data-page">
          <span data-translationkey="page">
            {props.access === "Public" && (
              <div
                id="reviewLabel."
                className="annotation-widget-data-reviewed"
              >
                <Icon
                  style={{ color: "#2ecc71", marginRight: "3px" }}
                  type="check-circle"
                />
                {props.access}
              </div>
            )}
            {props.access !== "Public" && (
              <div
                id="reviewLabel."
                className="annotation-widget-data-reviewed"
              >
                <Icon
                  style={{ color: "tomato", marginRight: "3px" }}
                  type="user"
                />
                {props.access}
              </div>
            )}
          </span>
        </div>
        <div className="annotation-widget-preview">
          <Icon type="user" />
        </div>
        <div className="annotation-widget-information">
          <div className="annotation-widget-type">
            <img className="d-none" src="https://bit.ly/2VgJpsq" alt="type" />
          </div>
          <div className="annotation-widget-data">
            <div className="annotation-widget-data-user">
              {props.creatorName}
            </div>
            <div className="annotation-widget-data-date">{props.time}</div>
          </div>
        </div>
      </div>
      <div className="annotation-note" id="annotationWidgetNote.">
        {props.text && props.text.replace(/\%20/g, " ").replace(/\%0A/g, " ")}
      </div>
      <footer id="annotation-widget-buttons" />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/NotesComponent.js